import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavBar from "./NavBar.jsx";
import Home from "./page.jsx";
import Contact from "./pages/contact/page.jsx";

import Completed from "./pages/projects/completed/page.jsx";
import OnGoing from "./pages/projects/ongoing/page.jsx";

import News from "./pages/media/news/page.jsx";
import Gallery from "./pages/media/gallery/page.jsx";


import Jobs from "./pages/careers/jobs/page.jsx";
import Internships from "./pages/careers/internships/page.jsx";

import Irrigation from "./pages/sectors/irrigation/page.jsx";
import Roadways from "./pages/sectors/roadways/page.jsx";
import Railways from "./pages/sectors/railways/page.jsx";
import Power from "./pages/sectors/power/page.jsx";
import Buildings from "./pages/sectors/buildings/page.jsx";
import TechnicalServices from "./pages/sectors/technical/page.jsx";
import FinancialServices from "./pages/sectors/financial/page.jsx";
function App() {
  return (
    <Router>
      <div className="d-flex flex-column min-vh-100 bg-white">
        <NavBar />
        {/* Define Routes Here */}
        <main className="flex-grow-1 bg-white">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
             {/* Sector Pages */}
             <Route path="/sectors/irrigation" element={<Irrigation />} />
            <Route path="/sectors/roadways" element={<Roadways />} />
            <Route path="/sectors/railways" element={<Railways />} />
            <Route path="/sectors/power" element={<Power />} />
            <Route path="/sectors/buildings" element={<Buildings />} />
            <Route path="/sectors/technical" element={<TechnicalServices />} />
            <Route path="/sectors/financial" element={<FinancialServices />} />

             {/* Project Pages */}
             <Route path="/projects/ongoing" element={<OnGoing />} />
             <Route path="/projects/completed" element={<Completed />} />

            {/* Media Pages */}
            <Route path="/media/news" element={<News />} />
            <Route path="/media/gallery" element={<Gallery />} />

            {/* Careets Pages */}
            <Route path="/careers/jobs" element={<Jobs />} />
            <Route path="/careers/internships" element={<Internships />} />

          </Routes>
        </main>
        <footer className="bg-primary text-white text-center py-3">
          <p className="mb-0">© {new Date().getFullYear()} Blueberry Infratech Pvt Ltd. All Rights Reserved.</p>
        </footer>
      </div>
    </Router>
  );
}

export default App;
